import React from 'react';

const defaultMetaValues = {
    title: 'Subito.it',
    description: 'Vendi e compra nuovo e usato online in modo semplice, rapido e sicuro. Oltre 6 milioni di annunci di auto, case, lavoro, elettronica, arredamento, animali e tanto altro',
    type: 'website',
    image: '',
    url: 'https://www.subito.it',
    siteName: 'Subito',
    locale: 'it_IT',
    twitterCard: 'summary_large_image',
    twitterAccount: '@Subitoit',
};

const ogMap = {
    title: { property: 'og:title', isOgMeta: true },
    type: { property: 'og:type', isOgMeta: true },
    image: { property: 'og:image', isOgMeta: true },
    url: { property: 'og:url', isOgMeta: true },
    siteName: { property: 'og:site_name', isOgMeta: true },
    // Even if there isn't any official limit about description, we prefer to limit the dimension to avoid to have a big value
    description: { property: 'og:description', maxLength: 250, isOgMeta: true },
    locale: { property: 'og:locale', isOgMeta: true },
    twitterCard: { property: 'twitter:card' },
    twitterAccount: { property: 'twitter:site' },
};
function getMetadata(social) {
    let k;
    const metadata = [];
    for (k in social) {
        const metaInfo = ogMap[k];
        if (metaInfo) {
            const { property, maxLength } = metaInfo;
            const props = {};
            //If the meta is an Og Meta use not standard property:
            props[metaInfo.isOgMeta ? 'property' : 'name'] = property;
            //Set content:
            let content = social[k];
            if (maxLength && content) {
                content = content.slice(0, maxLength).replace(/\n/g, ' ');
            }
            props.content = content;
            metadata.push(React.createElement("meta", { key: property, ...props }));
        }
    }
    return metadata;
}

/**
 * It returns the fullscreen version of the first photo of the ad.
 */
function getImage(images = []) {
    const firstImage = images?.[0]?.cdnBaseUrl;
    if (firstImage != null) {
        return `${firstImage}?rule=fullscreen-1x-auto`;
    }
    else {
        return undefined;
    }
}
const socialMeta = ({ ...data }) => {
    return getMetadata(data);
};
const socialMetaForAdItem = ({ adItem, fallbackImage, }) => {
    const data = {
        type: defaultMetaValues.type,
        title: `${adItem.subject.trim()} | Subito`,
        description: adItem.body,
        image: getImage(adItem.images) || fallbackImage || defaultMetaValues.image,
        url: adItem.urls.default,
        siteName: defaultMetaValues.siteName,
        locale: defaultMetaValues.locale,
        twitterCard: defaultMetaValues.twitterCard,
        twitterAccount: defaultMetaValues.twitterAccount,
    };
    return getMetadata(data);
};

const Meta = ({ assetsBase, socialTagsEnabled = true }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1, minimum-scale=1" }),
        React.createElement("meta", { name: "theme-color", content: "#ffffff" }),
        React.createElement("meta", { name: "format-detection", content: "telephone=no, address=no, email=no" }),
        React.createElement("link", { type: "application/opensearchdescription+xml", rel: "search", href: `${assetsBase}/static/metadata/osdd.xml` }),
        socialTagsEnabled ? socialMeta(defaultMetaValues) : null));
};

const Font = ({ assetsBase }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("link", { href: `${assetsBase}/static/fonts/LFTEtica-Book.woff2`, rel: "preload", as: "font", crossOrigin: "anonymous", type: "font/woff2" }),
        React.createElement("link", { href: `${assetsBase}/static/fonts/LFTEtica-Semibold.woff2`, rel: "preload", as: "font", crossOrigin: "anonymous", type: "font/woff2" }),
        React.createElement("link", { rel: "stylesheet", href: `${assetsBase}/static/fonts/LFTEtica-font-face.css` })));
};

const Icons = ({ assetsBase }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("link", { href: `${assetsBase}/static/icons/head/app-icon-192.png`, rel: "apple-touch-icon", sizes: "192x192" }),
        React.createElement("link", { rel: "icon", href: `${assetsBase}/static/icons/head/android_launcher_icon.png`, sizes: "192x192" }),
        React.createElement("link", { rel: "shortcut icon", href: `${assetsBase}/static/icons/head/favicon.ico`, type: "image/x-icon" })));
};

function HeadProperties({ assetsBase, socialTagsEnabled, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Icons, { assetsBase: assetsBase }),
        React.createElement(Meta, { assetsBase: assetsBase, socialTagsEnabled: socialTagsEnabled }),
        React.createElement(Font, { assetsBase: assetsBase })));
}

export { HeadProperties, defaultMetaValues as defaultSocialMetaValues, socialMeta, socialMetaForAdItem };
//# sourceMappingURL=index.js.map
